import wx from "weixin-js-sdk";
import { Toast } from 'vant'
import request from "./request.js"
import vuex from "../store"
const wxLocation = function () {
	const url = window.location.href.split("#")[0]; //获取当前的url
	//console.log(url)
	request.postURL("/api/activity/getWxLocation",{
		url:url
	})
	.then(res=>{
		//console.log(res)
		//--------初始化----------
		wx.config({
			debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
			appId: res.data.data.appid, // 必填，公众号的唯一标识
			timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
			nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
			signature: res.data.data.signature,// 必填，签名
			jsApiList: [
				'getLocation',
				'openLocation'
			] // 必填，需要使用的JS接口列表
		});
        wx.ready(function () { //如果wx.config配置正常，会自动走此处
			const toast=Toast.loading({
			  message: '',
			  forbidClick: true,
			  loadingType: 'spinner',				  
			});
			wx.getLocation({
			  type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
			  success: function (res) {
				  console.log(res)
			    var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
			    var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
			    var speed = res.speed; // 速度，以米/每秒计
			    var accuracy = res.accuracy; // 位置精度
				var userlocation={
					latitude:latitude,
					longitude:longitude
				}
				toast.clear()
				vuex.dispatch("getBranchByLocationAsync",userlocation)
			  },
			  fail: function(err) {
				  console.log(err)
					toast.clear()
					
			  }
			});
		
        });
        wx.error(function (res) { //如果wx.config配置失败,会走到此处
			console.log(res)
        })
	
    });

};

export default wxLocation//将此方法导出
